import React from "react";
import PropTypes from "prop-types";
import "./checkbox.css";

Checkbox.propTypes = {
  /** name given to input[type=checkbox] */
  name: PropTypes.string.isRequired,
  /** Text to display. Apllied to <Label> element */
  label: PropTypes.string.isRequired,
  /** Is the checkbox checked or nor */
  checked: PropTypes.bool.isRequired,
  /** function to run when the checkbox is clicked */
  onChange: PropTypes.func.isRequired,
  /** is the Checkbox disabled? */
  disabled: PropTypes.bool
};

export default function Checkbox({
  disabled = false,
  name,
  label,
  checked,
  onChange,
  style,
}) {
  const handler = !disabled ? onChange : undefined;

  return (
    <span className="checkbox" onClick={handler} style={{ display: 'flex' }}>
      <input
        required
        className="checkbox-input"
        type="checkbox"
        name={name}
        id={`${name}-id`}
        disabled={disabled}
        checked={checked}
        onChange={handler}
        area-labelledby="checkbox-label"
      />
      <span className="checkbox-indicator" />
      <label className="checkbox-label" htmlFor={`${name}-id`} style={style}>
        {label}
      </label>
    </span>
  );
}
